import { render, staticRenderFns } from "./MassMessageEditView.vue?vue&type=template&id=10b6ca17&scoped=true&"
import script from "./MassMessageEditView.vue?vue&type=script&lang=ts&"
export * from "./MassMessageEditView.vue?vue&type=script&lang=ts&"
import style0 from "./MassMessageEditView.vue?vue&type=style&index=0&id=10b6ca17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b6ca17",
  null
  
)

export default component.exports